import { render } from "./faq-list.vue?vue&type=template&id=5c8e6fa5"
import script from "./faq-list.vue?vue&type=script&lang=js"
export * from "./faq-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__